import React from 'react';
import type { GallerySite } from '../../data/gallery';
type GalleryCardProps = {
  site: GallerySite;
  onOpen: (site: GallerySite) => void;
};
export function GalleryCard({
  site,
  onOpen
}: GalleryCardProps) {
  return <button type="button" onClick={() => onOpen(site)} aria-label={`Preview ${site.name}`} className="group block w-full overflow-hidden rounded-xl border border-gray-200 bg-white text-left shadow-sm transition-shadow duration-200 ease-out hover:shadow-xl focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-red focus-visible:ring-offset-2" data-id="element-420" data-mp="fpwkze9ynwbx">
      <span className="relative block aspect-[4/3] overflow-hidden border-b border-gray-200 bg-gray-100" data-id="element-421" data-mp="zeosqydomema">
        <img src={site.image} alt="" loading="lazy" className="h-full w-full object-cover object-top transition-[object-position] duration-[6000ms] ease-linear group-hover:object-bottom motion-reduce:transition-none" data-id="element-422" data-mp="13fh0fn6wobgg" />
        {site.type === 'landing page' && <span className="absolute left-3 top-3 rounded-full bg-brand-black px-2.5 py-1 text-[11px] font-bold uppercase tracking-wide text-white" data-id="element-423" data-mp="pe4c7xpr466e">
            Landing page
          </span>}
      </span>
      <span className="block px-5 py-4" data-id="element-424" data-mp="gd6g01lk12yd">
        <span className="block text-xs font-bold uppercase tracking-[0.14em] text-brand-red" data-id="element-425" data-mp="bdtkksgmank6">{site.industry}</span>
        <span className="mt-1 block text-lg font-bold leading-snug text-brand-black" data-id="element-426" data-mp="184caa1elg6fq">{site.name}</span>
      </span>
    </button>;
}